import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  AdModal,
  TextArea,
  MyButton,
  MyMessage,
  PhoneInput,
  InputField,
  DashboardIntro,
  MyActionButton,
} from "../../home/component/Component";
import { codeOk } from "../../../middlewares/index";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneEvent } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const event = getOneEvent();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [showModal, setShowModal] = useState(false);
  const [thumbnail, setThumbnail] = useState(event?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(event?.image_cdn_id);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const event_id = event?.event_id;
  const [title, setTitle] = useState(event?.title);
  const [venue, setVenue] = useState(event?.venue);
  const [venueCapacity, setVenueCapacity] = useState(event?.venue_capacity);
  const [startDate, setStartDate] = useState(event?.start_date);
  const [endDate, setEndDate] = useState(event?.end_date);
  const [startTime, setStartTime] = useState(event?.start_time);
  const [endTime, setEndTime] = useState(event?.end_time);
  const [email, setEmail] = useState(event?.email_address);
  const [phoneNumber, setPhoneNumber] = useState(event?.phone_number);
  const [whatsapp, setWhatsapp] = useState(event?.whatsapp);
  const [facebook, setFacebook] = useState(event?.facebook);
  const [twitter, setTwitter] = useState(event?.twitter);
  const [instagram, setInstagram] = useState(event?.instagram);
  const [youtube, setYoutube] = useState(event?.youtube);
  const [hashtags, setHashtags] = useState(event?.hashtag);
  const [repeatEvery, setRepeatEvery] = useState(event?.repeat_every);
  const [googleMapCode, setGoogleMapCode] = useState(event?.google_map_code);
  const [latitude, setLatitude] = useState(event?.latitude);
  const [longitude, setLongitude] = useState(event?.longitude);
  const [formattedAddress, setFormattedAddress] = useState(
    event?.formatted_address
  );
  const [featured, setFeatured] = useState(event?.featured);
  const [promoted, setPromoted] = useState(
    event?.promoted ? event?.promoted : "no"
  );
  const [eventStatus, setEventStatus] = useState(event?.status);
  const [description, setDescription] = useState(event?.description);
  const [expo, setExpo] = useState(event?.expo);
  const [showTop, setShowTop] = useState(event?.show_top);
  const [pricing, setPricing] = useState(event?.Pricings);
  const [payLink, setPayLink] = useState(event?.pay_link);

  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const eventRoutes = "/data/event";

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : event?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level_label",
      venue: venue,
      venue_capacity: venueCapacity,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: eventStatus,
      featured: featured,
      promoted: promoted,
      repeat_every: repeatEvery,
      expo: expo,
      show_top: showTop,
      pricing,
      pay_link: payLink,
    };

    const { message, status } = await updateOneContent({
      data_id: event_id,
      data: data,
      content: _TYPES_.EVENT,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "px-4 sm:px-5 py-4";
  const btnBase =
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: eventRoutes }} />
          <MyButton
            title="Position Event"
            className={`${btnBase} ${btnPrimary}`}
            onClick={() => setShowModal(true)}
          />
        </div>

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Edit Event`, name: entry_label }} />
        </div>

        {showModal ? (
          <AdModal
            event_id={event_id}
            name={title}
            setShowModal={() => setShowModal(false)}
          />
        ) : null}

        <form onSubmit={updateOneEventHandler}>
          <div className="mt-2 flex flex-col items-center justify-center font-medium text-sm md:text-base gap-6">
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Cover Image" }} />
              </div>
              <div className={sectionPad}>
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={image_kit_folder(country_name, FOLDERS.EVENTS)}
                />
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Event Details" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
                  <InputField
                    props={{
                      id: "title",
                      title: "Title",
                      type: "text",
                      value: title ? title : "",
                      onChange: (e) => {
                        setTitle(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "top",
                      title: "Show In Top Events",
                      option: ["no", "yes"],
                      preselect:
                        showTop !== null
                          ? [{ name: showTop === 0 ? "no" : "yes" }]
                          : null,
                      onChange: (e) => {
                        if (e.target.selectedIndex === 0) setShowTop(0);
                        else setShowTop(1);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "venue",
                      title: "Venue",
                      type: "text",
                      value: venue ? venue : "",
                      onChange: (e) => {
                        setVenue(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "venue_capacity",
                      title: "Venue Capacity",
                      type: "number",
                      value: venueCapacity ? venueCapacity : "",
                      onChange: (e) => {
                        setVenueCapacity(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "formatted_address",
                      title: "Formatted Address",
                      type: "address",
                      value: formattedAddress ? formattedAddress : "",
                      onChange: (e) => {
                        setFormattedAddress(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Date & Time" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
                  <InputField
                    props={{
                      id: "start_date",
                      title: "Start Date",
                      type: "date",
                      value: startDate ? startDate : "",
                      onChange: (e) => {
                        setStartDate(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "end_date",
                      title: "End Date",
                      type: "date",
                      value: endDate ? endDate : "",
                      onChange: (e) => {
                        setEndDate(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "start_time",
                      title: "Start Time",
                      type: "time",
                      value: startTime ? startTime : "",
                      onChange: (e) => {
                        setStartTime(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "end_time",
                      title: "End Time",
                      type: "time",
                      value: endTime ? endTime : "",
                      onChange: (e) => {
                        setEndTime(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>

                <div className="pt-5 w-full">
                  <p className="text-sm font-medium text-slate-700">
                    Repeat Every:
                  </p>
                  <div className="flex gap-4 overflow-x-auto w-full text-sm py-3">
                    {[
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                      "sunday",
                      "annual",
                    ].map((val, key) => (
                      <div
                        key={key}
                        className="flex flex-col items-center capitalize min-w-[72px]"
                      >
                        <p className="text-slate-700">{val}</p>
                        {repeatEvery?.toString().split("|").includes(val) ? (
                          <MdCheckBox
                            onClick={() => {
                              let rep = "";
                              repeatEvery
                                ?.split("|")
                                .filter((day) => val !== day)
                                .map((weekday) => (rep += `${weekday}|`));
                              setRepeatEvery(rep);
                            }}
                            className="text-2xl text-blue-600 cursor-pointer"
                          />
                        ) : (
                          <MdCheckBoxOutlineBlank
                            onClick={() => {
                              let rep = "";
                              if (repeatEvery) {
                                [...repeatEvery.split("|"), val].map(
                                  (weekday) => (rep += `${weekday}|`)
                                );
                                setRepeatEvery(rep);
                              } else {
                                setRepeatEvery(val);
                              }
                            }}
                            className="text-2xl text-slate-400 cursor-pointer"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Pricing" }} />
              </div>
              <div className={sectionPad}>
                <Pricing pricing={pricing} setPricing={setPricing} />
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Contact Info" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
                  <div className="flex flex-row justify-center items-center">
                    <PhoneInput
                      setPhone={setPhoneNumber}
                      phone={phoneNumber}
                      required={false}
                    />
                  </div>
                  <InputField
                    props={{
                      id: "email",
                      title: "Email Address",
                      type: "email",
                      value: email ? email : "",
                      onChange: (e) => {
                        setEmail(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "pay-link",
                      title: "Pay Link (Optional)",
                      type: "text",
                      value: payLink ? payLink : null,
                      onChange: (e) => {
                        setPayLink(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Social Contact" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
                  <InputField
                    props={{
                      id: "whatsapp",
                      title: "Whatsapp",
                      type: "text",
                      value: whatsapp ? whatsapp : "",
                      onChange: (e) => {
                        setWhatsapp(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "facebook",
                      title: "Facebook",
                      type: "text",
                      value: facebook ? facebook : "",
                      onChange: (e) => {
                        setFacebook(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "twitter",
                      title: "Twitter",
                      type: "text",
                      value: twitter ? twitter : "",
                      onChange: (e) => {
                        setTwitter(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "instagram",
                      title: "Instagram",
                      type: "text",
                      value: instagram ? instagram : "",
                      onChange: (e) => {
                        setInstagram(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "youtube",
                      title: "YouTube",
                      type: "text",
                      value: youtube ? youtube : "",
                      onChange: (e) => {
                        setYoutube(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Geo Position" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 w-full">
                  <InputField
                    props={{
                      id: "google_map_code",
                      title: "Google Map Code",
                      type: "text",
                      value: googleMapCode ? googleMapCode : "",
                      onChange: (e) => {
                        setGoogleMapCode(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "latitude",
                      title: "Latitude",
                      type: "text",
                      value: latitude ? latitude : "",
                      onChange: (e) => {
                        setLatitude(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "longitude",
                      title: "Longitude",
                      type: "text",
                      value: longitude ? longitude : "",
                      onChange: (e) => {
                        setLongitude(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div
                className={`${sectionPad} border-b flex items-center justify-between`}
              >
                <Title props={{ title: "Description" }} />
                <MyButton
                  onClick={() => setShowDescriptionModal(true)}
                  className={`${btnBase} ${btnPrimary}`}
                >
                  Generate Description
                </MyButton>
              </div>
              <div className={sectionPad}>
                <TextArea
                  props={{
                    id: "description",
                    title: "Description",
                    type: "text",
                    value: description ? description : "",
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full pt-4">
                  <InputField
                    props={{
                      id: "hashtag",
                      title: "Tags (comma separated)",
                      type: "text",
                      value: hashtags ? hashtags : "",
                      onChange: (e) => {
                        setHashtags(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "More Settings" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
                  <Select
                    props={{
                      id: "event_status",
                      title: "Status",
                      option: ["visible", "invisible"],
                      preselect:
                        eventStatus !== null
                          ? [
                              {
                                name:
                                  eventStatus === 1 ? "visible" : "invisible",
                              },
                            ]
                          : null,
                      onChange: (e) => {
                        if (e.target.selectedIndex === 0) setEventStatus(1);
                        else setEventStatus(0);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "featured",
                      title: "Featured",
                      option: ["no", "yes"],
                      preselect:
                        featured !== null ? [{ name: featured }] : null,
                      onChange: (e) => {
                        setFeatured(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "promoted",
                      title: "Promoted",
                      option: ["no", "yes"],
                      preselect:
                        promoted !== null ? [{ name: promoted }] : null,
                      onChange: (e) => {
                        setPromoted(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "gallery",
                      title: "Show in Gallery",
                      option: ["no", "yes"],
                      preselect:
                        expo !== null
                          ? [{ name: expo === 0 ? "no" : "yes" }]
                          : null,
                      onChange: (e) => {
                        const choice = e.target.value;
                        setExpo(choice === "no" ? 0 : 1);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="w-full sticky bottom-0">
              <div className="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-t border-slate-200 px-4 sm:px-5 py-3 rounded-b-xl">
                <MyActionButton
                  loading={loading}
                  title="Save Changes"
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage(null);
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
